/**
 * Shared toPascalCase utility.
 *
 * Converts any display-friendly subject name into the PascalCase identifier
 * used as a Firestore subcollection name under PDFS/{Grade}/{Subject}.
 *
 * Examples:
 *   "Business Studies"             → "BusinessStudies"
 *   "First Additional language"    → "FirstAdditionalLanguage"
 *   "Technical: Civil Technology"  → "TechnicalCivilTechnology"
 *   "Natural Science and Technology" → "NaturalScienceAndTechnology"
 *   "Life Science"                 → "LifeScience"
 *
 * The function strips colons, hyphens, underscores and whitespace, then
 * capitalises the first letter of every resulting word.
 */
export default function toPascalCase(str) {
  return str
    .replace(/[:\-_\s]+/g, ' ')   // normalise all delimiters to a single space
    .trim()
    .split(' ')
    .filter(Boolean)               // drop empty strings from consecutive delimiters
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}
